import { render, staticRenderFns } from "./cdyyDyzhww.vue?vue&type=template&id=651977b2&scoped=true"
import script from "./cdyyDyzhww.vue?vue&type=script&lang=js"
export * from "./cdyyDyzhww.vue?vue&type=script&lang=js"
import style0 from "./cdyyDyzhww.vue?vue&type=style&index=0&id=651977b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651977b2",
  null
  
)

export default component.exports